import 'alpinejs';
import { gsap } from 'gsap';
import { GSDevTools } from 'gsap/GSDevTools';

gsap.registerPlugin(GSDevTools);

// GSDevTools.create();

/**
 * button chevron right animation on hover
 */

function animateButtonChevronRight () {
  this.timeline.reversed(!this.timeline.reversed());
}

gsap.utils.toArray('.button-chevron-right').forEach(button => {
  let timeline = button.timeline = gsap.timeline({ease: 'power4'});
  timeline.to(button.children[1], {duration: 0.3, rotate: 180, x: 2}, 0);
  timeline.to(button.children[0], {duration: 0.3, x: -2,}, '<');
  timeline.to(button.children[1], {duration: 0.3, x: -2,});
  timeline.to(button.children[0], {duration: 0.3, x: 2,}, '<');
  button.timeline.reversed(true);
  button.addEventListener('mouseenter', animateButtonChevronRight.bind(button));
  button.addEventListener('mouseleave', animateButtonChevronRight.bind(button));
});
